import NoAssignment from '../../../assets/images/NoAssignment.png';
import PropTypes from 'prop-types';
import { useMyContentContext } from '../utils/myContentContext';
import { useSelector } from 'react-redux';
import { selectCurrentUserData } from '../../../features/authentication/authSlice';
import { useEffect, useState } from 'react';
import UserTypes from '../../../enums/userTypes';
import useImportXml from '../utils/useImportXml';
import ImportXmlModal from './ImportXmlModal';

const EmptySet = ({
  handleCreateSet,
  showDeletedSets,
  handleShowDeletedChanges,
  showDisplayDeletedSetCheckbox,
  onImportSuccess
}) => {
  const { activeTab } = useMyContentContext();
  const user = useSelector(selectCurrentUserData);
  const [name, setName] = useState('');

  const {
    openImportXmlModal,
    importFile,
    isImportWaiting,
    importLoadingProgress,
    handleImportQuestionSet,
    handleImportFileChange,
    handleUploadImportXml,
    closeModal
  } = useImportXml(onImportSuccess);

  useEffect(() => {
    switch (activeTab) {
    case 'questionsets':
      setName('Question');
      break;
    case 'flashcardsets':
      setName('Flash Card');
      break;
    case 'resourcesets':
      setName('Resource');
      break;
    default:
      setName('');
    }
  }, [activeTab]);

  return (
    <>
      {showDisplayDeletedSetCheckbox &&
        <div className="d-flex align-items-center form-check col-auto">
          <input
            type="checkbox"
            id="displayDeletedSets"
            className="form-check-input mx-1 ms-auto"
            checked={showDeletedSets}
            onChange={() => handleShowDeletedChanges()}
          />
          <label className="form-check-label" htmlFor="displayDeletedSets">
            Display Deleted Sets
          </label>
        </div>
      }
      <div className='mb-0 my-4 no-content-card'>
        <div className="text-center mb-5">
          <img src={NoAssignment} className='my-4' />
          <p className='mb-4'>
            {name} set is currently empty, use the <strong>Add buttons</strong> to add {name.toLowerCase()} set.
          </p>
          <div className='col-md-6 d-flex gap-3 justify-content-center w-100'>
            <button onClick={() => handleCreateSet()} className='btn btn-castleRed'>
              Add {name} Set
            </button>
            {activeTab === 'questionsets' && [UserTypes.SuperAdministrator, UserTypes.Sales, UserTypes.SuperSales, UserTypes.Trainer].includes(user?.UserType) && (
              <button onClick={() => handleImportQuestionSet()} className='btn outline-btn'>
                Import Question Set
              </button>
            )}
          </div>
        </div>
      </div>
      {openImportXmlModal && (
        <ImportXmlModal
          isOpen={openImportXmlModal}
          importFile={importFile}
          isImportWaiting={isImportWaiting}
          importLoadingProgress={importLoadingProgress}
          handleImportFileChange={handleImportFileChange}
          handleUploadImportXml={handleUploadImportXml}
          onClose={closeModal}
        />
      )}
    </>
  );
};

EmptySet.propTypes = {
  handleCreateSet: PropTypes.func,
  showDeletedSets: PropTypes.bool,
  handleShowDeletedChanges: PropTypes.func,
  showDisplayDeletedSetCheckbox: PropTypes.bool,
  onImportSuccess: PropTypes.func
};

export default EmptySet;